module.exports = __webpack_public_path__ + "static/media/smile.36cf45e7.svg";